import { TextQuestion, RadioQuestion, MultiselectQuestion } from './components';

const Question = (props) => {
    const { question, questionnaireIndex, questionIndex, editMode, name = null } = props;

    return (
        <>
            {question.TypeId === 30 && !question?.AcceptsMultipleAnswers && (
                <RadioQuestion
                    question={question}
                    questionnaireIndex={questionnaireIndex}
                    questionIndex={questionIndex}
                    editMode={editMode}
                    name={name}
                />
            )}
            {question.TypeId === 30 && question?.AcceptsMultipleAnswers && (
                <MultiselectQuestion
                    question={question}
                    questionnaireIndex={questionnaireIndex}
                    questionIndex={questionIndex}
                    editMode={editMode}
                    name={name}
                />
            )}
            {question.TypeId === 10 && (
                <TextQuestion
                    question={question}
                    questionnaireIndex={questionnaireIndex}
                    questionIndex={questionIndex}
                    editMode={editMode}
                    name={name}
                />
            )}
        </>
    );
};

export default Question;
